<template>
  <mf-loading-dialog :loading="$apollo.loading">
    <div class="whatsapp-home">
      <v-row class="px-3" justify="end">
        <mf-button v-if="hasPiiAccess" label="Ver lista de contatos" text to="whatsapp/nova" @click="dialog = true" />
        <mf-button icon="add" label="Nova campanha" class="ml-2" @click="$router.push('whatsapp/nova')" />
        <whatsapp-contacts-list v-model="dialog" />
      </v-row>
      <v-container fluid class="pa-0">
        <v-row>
          <v-col v-for="(card, index) in cards" :key="index">
            <cbm-card
              :number-text="card.value"
              :title="card.text"
              :percent-text="card.underText"
              :percent-description="card.description"
              unset-percentage-colors
            />
          </v-col>
        </v-row>
      </v-container>

      <campaigns-table mode="whatsapp" :items-filter="filterList">
        <template v-slot:title> Minhas campanhas </template>
      </campaigns-table>
    </div>
  </mf-loading-dialog>
</template>

<script>
import gql from 'graphql-tag'
import { localeString, getStatusLabel } from '@/config/helpers.js'
import { DateTime } from 'luxon'

const QUERY_GET_NUMBER_OF_CONTACTS = gql`
  query GetNumberOfContacts($initial_date: String, $final_date: String, $active: Boolean) {
    getNumberOfContacts(initial_date: $initial_date, final_date: $final_date, active: $active) {
      total
      loyalty
      non_loyalty
    }
  }
`

export default {
  components: {
    CampaignsTable: () => import('@/modules/campanhas/views/components/index/CampaignsTable.vue'),
    CbmCard: () => import('@/components/CbmCard.vue'),
    WhatsappContactsList: () => import('@/modules/campanhas/whatsapp/views/components/WhatsappContactsList.vue'),
  },
  data: () => ({
    totalSubscriptions: 0,
    todaySubscriptions: 0,
    lastSevenDaysSubscriptios: 0,
    lastThirtyDaysSubscriptions: 0,
    unsubscribeds: 0,
    dialog: false,
    filterList: [
      { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
      { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
      { label: getStatusLabel('DRAFT').text, value: 'DRAFT', color: getStatusLabel('DRAFT').color, active: true },
      { label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true },
    ],
  }),
  computed: {
    today() {
      return DateTime.now().toFormat('yyyy-MM-dd')
    },
    sevenDaysBehind() {
      return DateTime.now().plus({ days: -7 }).toFormat('yyyy-MM-dd')
    },
    thirtyDaysBehind() {
      return DateTime.now().plus({ days: -30 }).toFormat('yyyy-MM-dd')
    },
    cards() {
      return [
        {
          text: 'Total de inscritos',
          value: localeString(this.totalSubscriptions),
          underText: `${localeString(this.todaySubscriptions)} ${this.todaySubscriptions === 1 ? 'inscrito' : 'inscritos'} hoje`,
        },
        {
          text: 'Inscritos nos últimos 7 dias',
          value: localeString(this.lastSevenDaysSubscriptios || 0),
          underText: `${this.getPercentOfBase(this.lastSevenDaysSubscriptios)}%`,
          description: `da quantidade total inscrita`,
        },
        {
          text: 'Inscritos nos últimos 30 dias',
          value: localeString(this.lastThirtyDaysSubscriptions || 0),
          underText: `${this.getPercentOfBase(this.lastThirtyDaysSubscriptions)}%`,
          description: `da quantidade total inscrita`,
        },
        {
          text: 'Total de desistências',
          value: localeString(this.unsubscribeds || 0),
          underText: `${this.getPercentOfBase(this.unsubscribeds)}%`,
          description: `da quantidade total inscrita`,
        },
      ]
    },
  },
  apollo: {
    totalSubscriptions: {
      query: QUERY_GET_NUMBER_OF_CONTACTS,
      update({ getNumberOfContacts }) {
        return getNumberOfContacts?.total || 0
      },
    },
    todaySubscriptions: {
      query: QUERY_GET_NUMBER_OF_CONTACTS,
      variables() {
        return {
          initial_date: this.today,
          final_date: this.today,
        }
      },
      update({ getNumberOfContacts }) {
        return getNumberOfContacts?.total || 0
      },
    },
    lastSevenDaysSubscriptios: {
      query: QUERY_GET_NUMBER_OF_CONTACTS,
      variables() {
        return {
          initial_date: this.sevenDaysBehind,
          final_date: this.today,
        }
      },
      update({ getNumberOfContacts }) {
        return getNumberOfContacts?.total || 0
      },
    },
    lastThirtyDaysSubscriptions: {
      query: QUERY_GET_NUMBER_OF_CONTACTS,
      variables() {
        return {
          initial_date: this.thirtyDaysBehind,
          final_date: this.today,
        }
      },
      update({ getNumberOfContacts }) {
        return getNumberOfContacts?.total || 0
      },
    },
    unsubscribeds: {
      query: QUERY_GET_NUMBER_OF_CONTACTS,
      variables: {
        active: false,
      },
      update({ getNumberOfContacts }) {
        return getNumberOfContacts?.total || 0
      },
    },
  },
  methods: {
    getPercentOfBase(quantity) {
      if (!this.totalSubscriptions) return localeString(0, 1)
      return localeString((quantity / this.totalSubscriptions) * 100, 1)
    },
  },
}
</script>

<style lang="scss">
.whatsapp-home {
  .home-title {
    font-size: 28px;
    font-weight: normal;
    letter-spacing: 0.6px;
    color: $cinza-d20;
  }
}

.table-card-title-whats {
  font-size: 18px;
  color: $cinza-d10;
  @extend .card-title;
}
</style>
